/* global $ */
import _ from 'lodash';
import angular from 'angular';
import ComponentsModule from '../components-module';
import RecentContentModalTemplate from '../recent-content-list/recent-modal-template.html';

const COMPONENT_NAME = 'RecentContentService';
const LOCAL_STORAGE_NAME = 'atex.code.recentContent';
const MAX_RECENT_CONTENT_ITEMS = 10;
const fetchRecentContent = () => { return JSON.parse(localStorage.getItem(LOCAL_STORAGE_NAME)) || []; };

/**
 * Recent content service, responsible for keeping track of
 * contents recently visited (edited) by the user.
 */
angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, function ($rootScope, ContentCardService, WorkspaceService, $uibModal, AuthenticationService, KeyboardShortcutService) {

    var showRecentContentDialog = function showRecentContentDialog () {
      var dialog = $('.recent-dialog');

      if (!dialog.length || !dialog.filter(':visible').length) {
        let modalScope = $rootScope.$new(true);

        const modal = $uibModal.open({
          scope: modalScope,
          template: RecentContentModalTemplate,
          windowClass: 'recent-dialog ng-cloak',
          keyboard: false,
          size: 'centered'
        });

        modal.opened.then(() => {
          KeyboardShortcutService.hideAndPush({
            global: {
              'escape': {
                action: (event) => {
                  modalScope.$apply(function () {
                    event.stopPropagation();
                    event.preventDefault();
                    modalScope.close();
                  });
                },
                label: 'keyboard-shortcuts.close-recent-content.label'
              }
            }
          });
        });

        modal.result.catch(() => {
          modalScope.close();
        });

        modalScope.close = () => {
          modal.close();
          modalScope.$destroy();
        };

        modalScope.$on('$destroy', () => {
          KeyboardShortcutService.pop();
        });
      }
    };

    let onLogout = () => {
      localStorage.removeItem(LOCAL_STORAGE_NAME);
    };

    $rootScope.$on('aceui:userLoggedOut', onLogout);

    KeyboardShortcutService.push({
      global: {
        'mod+k': {
          action: () => {
            showRecentContentDialog();
            return false;
          },
          label: 'keyboard-shortcuts.open-recent-content.label'
        }
      }
    });

    return {
      addContent: (contentId, forceFetch, isAutosaved) => {
        const recentContent = fetchRecentContent();
        const existingIndex = recentContent.findIndex((item) => item.id === contentId);
        let existingItem = undefined;

        if (existingIndex !== -1) {
          existingItem = recentContent.splice(existingIndex, 1)[0];

          if (!forceFetch) {
            existingItem.autosaved = isAutosaved;
            recentContent.unshift(existingItem);
            localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));
            return;
          }
        }

        if (recentContent.length >= MAX_RECENT_CONTENT_ITEMS) {
          recentContent.pop();
        }

        var recentContentEntry = {
          id: contentId
        };

        if (typeof existingItem !== 'undefined') {
          recentContentEntry.editorState = existingItem.editorState || {};
        }

        recentContent.unshift(recentContentEntry);
        localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));

        AuthenticationService.getCurrentUser().then((user) => {
          var workspace = user.userId + '-workspace';

          return WorkspaceService.getContent({
            alias: contentId,
            variant: 'aceUISearch',
            workspace: workspace,
            fullTypeInfo: true
          })
            .then((result) => {
              const recentContent = fetchRecentContent();
              const recentContentEntry = recentContent[recentContent.findIndex((content) => content.id === contentId)];

              if (!recentContentEntry) {
                return;
              }

              let contentCard = ContentCardService.fromAceUISearch (result.content);

              Object.assign (recentContentEntry, {
                creationDate: new Date(atex.aceui.ObjectUtils.getByPath (result, 'content/system/creationTime')),
                autosaved: result.content.system.version.endsWith(':WORKSPACE-' + workspace),
                contentType: result.content.system.contentType,
                contentCard: contentCard.getContextual ({
                  label: { rows: 1 },
                  thumbnail: {
                    width: 40,
                    aspectRatio: '1:1'
                  },
                  contentType: {
                    label: result.content.system.contentType
                  }
                }, 'LIST', 'RECENT-CONTENT')
              });

              localStorage.setItem (LOCAL_STORAGE_NAME, angular.toJson (recentContent));

              if (recentContentEntry.contentCard.thumbnail && recentContentEntry.contentCard.thumbnail.alias) {
                ContentCardService.resolveThumbnail (recentContentEntry.contentCard.thumbnail)
                  .then ((thumbnail) => {
                    const recentContent = fetchRecentContent();
                    const recentContentEntry = recentContent[recentContent.findIndex((content) => content.id === contentId)];

                    if (!recentContentEntry.contentCard) {
                      recentContentEntry.contentCard = {};
                    }

                    if (recentContentEntry.autosaved) {
                      recentContentEntry.contentCard.label.value = '* ' + recentContentEntry.contentCard.label.value;
                    }

                    recentContentEntry.contentCard.thumbnail = thumbnail;
                    localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));
                  })
                  .catch ((error) => {
                    console.log (error);
                  });
              }
            })
            .catch((error) =>  {
              console.warn('Error while loading \'' + contentId + '\' for recent content tracking!', error);
            });
        });
      },


      // If alias is provided return it if it exists as recentContent or undefined
      // If no alias, return a list of recentContent
      getRecentContent: (alias) => {
        const recentContent = fetchRecentContent();

        if (alias) {
          return recentContent.find((content) => content.id === alias);
        }

        return recentContent.slice(0, MAX_RECENT_CONTENT_ITEMS);
      },

      removeContent: (contentId) => {
        const recentContent = fetchRecentContent();
        const existingIndex = recentContent.findIndex((content) => content.id === contentId);

        if (existingIndex !== -1) {
          recentContent.splice(existingIndex, 1)[0];
          localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));
        }
      },

      getEditorStateFor: (contentId) => {
        const recentContent = fetchRecentContent();
        const existingIndex = recentContent.findIndex((content) => content.id === contentId);

        return (existingIndex < 0) ? {} : (recentContent[existingIndex].editorState || {});
      },

      updateEditorStateFor: (contentId, editorState) => {
        const recentContent = fetchRecentContent();
        const existingIndex = recentContent.findIndex((content) => content.id === contentId);

        if (existingIndex !== -1) {
          recentContent[existingIndex].editorState = _.extend({}, recentContent[existingIndex].editorState, editorState);
          localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));
        }
      },
      updateHiddenState: (alias, isHidden) => {
        const recentContent = fetchRecentContent();
        const existingIndex = recentContent.findIndex((content) => content.id === alias);

        if (existingIndex !== -1) {
          recentContent[existingIndex].isHidden = isHidden;
          localStorage.setItem(LOCAL_STORAGE_NAME, angular.toJson(recentContent));
        }
      },

      showRecentContentDialog
    };
  });

export default COMPONENT_NAME;
